import { render, staticRenderFns } from "./Sexygame.vue?vue&type=template&id=47559219&scoped=true&"
import script from "./Sexygame.vue?vue&type=script&lang=js&"
export * from "./Sexygame.vue?vue&type=script&lang=js&"
import style0 from "./Sexygame.vue?vue&type=style&index=0&id=47559219&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47559219",
  null
  
)

export default component.exports